import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Grid } from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import { LabelCompo } from "../../components/Comman/Label";
import endpoint from "../../config/endpoints";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { getUpdatedBeatByUserType } from "../../Slice/beat.slice";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadF } from "../PDF/PDFDownload";
import { redColor, titleColor } from "../../config/ColorObj";
import NewMultipleSelect from "../../components/Comman/NewMultipleSelect";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const ChangeOutletBeatExportPopUp = ({
  handleCloses,
  open,
  showNotification,
  showLoador,
  getUpdatedBeatByUserType,
  beatList,
}) => {
  const [beatIds, setBeatIds] = React.useState([]);
  const [beatIdsToStore, setBeatIdsToStore] = React.useState([]);
  const [formError, setFormError] = React.useState({});

  React.useEffect(() => {
    if (navigator.onLine) {
      showLoador({ loador: true });
      getUpdatedBeatByUserType().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }, []);

  const handleClose = () => {
    handleCloses();
  };

  const checkValidation = () => {
    let formErrors = {};
    let formIsValid = true;

    if (
      beatIdsToStore.length == 0 ||
      beatIdsToStore == null ||
      beatIdsToStore == undefined
    ) {
      formIsValid = false;
      formErrors["beatError"] = "Please select beat";
    }

    console.debug(formErrors);

    setFormError(formErrors);
    return formIsValid;
  };

  const onExport = async () => {
    if (navigator.onLine) {
      if (checkValidation()) {
        let beatIdsJson = {
          beatIds: beatIdsToStore,
        };
        showLoador({ loador: true });
        downloadF({
          isGet: false,
          url: endpoint.exportData + "/get-reassign-outlet-beat-export-excel",
          postBody: beatIdsJson,
          ext: "xls",
          openNewTab: false,
          isShowSalesPersonName: true,
          reportName: "Change-Outlet-Beat-Import-Export",
        }).then((response) => {
          showLoador({ loador: false });
          if (!response) {
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          }
        });
      }
    } else {
      showNotification({ msg: serverMsg, severity: "error" });
    }
  };

  const onBeatChangeHandler = (value, name) => {
    let updatedValue = [...value];

    const isAllSelected = updatedValue.includes("all");
    if (isAllSelected) {
      let allIds = [];

      if (name === "beat") {
        allIds = beatList?.beatByUserType.map((data) => data.id);
        setBeatIds(["all"]);
        setBeatIdsToStore(allIds);
      }
    } else {
      updatedValue = updatedValue.filter((id) => id !== "all");

      if (name === "beat") {
        setBeatIds(updatedValue);
        setBeatIdsToStore(updatedValue);
      }
    }
  };

  return (
    <>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: "70%",
            borderRadius: "12px",
          },
        }}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Export
        </BootstrapDialogTitle>
        <DialogContent dividers sx={{ backgroundColor: " #f7f8fa" }}>
          <Grid item xs={12} md={12} container spacing={2} alignItems="center">
            <Grid item xs={12} md={6} container alignItems="center">
              <Grid item xs={12} md={4} display="flex" alignItems="center">
                <LabelCompo
                  style={{ fontSize: 16, color: redColor }}
                  label="* "
                />
                <LabelCompo
                  style={{
                    fontSize: 16,
                    color: titleColor,
                    marginRight: "8px",
                  }}
                  label="Beat:"
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <div style={{ width: "100%", minWidth: "350px" }}>
                  <NewMultipleSelect
                    er={formError["beatError"] || ""}
                    label={"Select Beat"}
                    name1="beat"
                    value1={beatIds}
                    names={[
                      { id: "all", name: "All" },
                      ...beatList?.beatByUserType,
                    ]}
                    onChange={onBeatChangeHandler}
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogContent dividers>
          <Grid
            container
            xs={12}
            sm={12}
            md={12}
            spacing={1}
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="outlined"
                  color="secondary"
                  size="medium"
                  startIcon={<CloudDownloadIcon />}
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    transition: "all 0.2s",
                    minWidth: "120px",
                    height: "35px",
                    "&:hover": {
                      backgroundColor: "#f4f6fa",
                      borderColor: "#1976d2",
                      color: "#1976d2",
                      transform: "translateY(-2px)",
                    },
                  }}
                  onClick={onExport}
                >
                  Export
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};
const mapStateToProps = (state) => ({
  beatList: state.beat,
});

const mapDispatchToProps = {
  showNotification,
  showLoador,
  getUpdatedBeatByUserType,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeOutletBeatExportPopUp);
